<template>
    <div>
      <img src="/static/images/spinner.svg" :style="{ width: size, height: size }">
    </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    size: {
      type: String,
      default: '128px'
    }
  }
}
</script>

<style>
</style>
